import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { SubmissionStatusModuleName } from '@/store/modules/modules'

export class SubmissionStatusViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelData: string[]; chartData: number[][] }> = computed(
    () => this.store.getters[`${SubmissionStatusModuleName}/chartData`]
  )
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${SubmissionStatusModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${SubmissionStatusModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${SubmissionStatusModuleName}/hasData`])

  setChartData(chartData: { labelData: string[]; chartData: number[][] }): void {
    this.store.commit(`${SubmissionStatusModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${SubmissionStatusModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${SubmissionStatusModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${SubmissionStatusModuleName}/setHasData`, hasData)
  }
}
